import { Job } from "@freeconvert/freeconvert-node/dist/types";
import { get } from "../Backend/get";
import { JobSocket } from "./JobSocket";

export interface JobServiceOptions {
    handleDisconnect?: () => void;
    handleReconnect?: () => void;
    handleJobComplete: (job: Job) => void;
    handleJobFail: (job: Job) => void;
    onOfflineLimitReach?: (job: Job) => void;
}

export class JobService {
    private job: Job;
    private options: JobServiceOptions;
    private isComplete = false;

    public constructor(job: Job, options: JobServiceOptions) {
        this.job = job;
        this.options = options;

        this.init();
    }

    private async init() {
        // check after 5 seconds incase of socket failure or edge case
        setTimeout(() => this.checkStatus(), 5000);
        this.initSocket();
    }

    private async initSocket() {
        new JobSocket(this.job, {
            handleDisconnect: this.options.handleDisconnect,
            handleReconnect: this.options.handleReconnect,
            handleJobComplete: this.handleJobComplete,
            handleJobFail: this.handleJobFail,
            onOfflineLimitReach: this.options.onOfflineLimitReach,
        });
    }

    private async checkStatus() {
        if (this.isComplete) return;
        const { result, error } = await get<Job>(`/api/jobs/${this.job.id}`);

        if (error || !result) {
            this.handleJobFail(this.job);
            return;
        }

        if (result.status === "completed") {
            this.handleJobComplete(result);
            return;
        }

        if (result.status === "failed") {
            this.options;
        }
    }

    private handleJobComplete = async (job: Job) => {
        if (this.isComplete) return;

        if (job.status !== "completed") {
            const { result, error } = await get<Job>(`/api/jobs/${job.id}`);

            if (error || !result) {
                return;
            }

            this.isComplete = true;
            this.options.handleJobComplete(result);
            return;
        }

        this.isComplete = true;
        this.options.handleJobComplete(job);
    };

    private handleJobFail = (job: Job) => {
        this.options.handleJobFail(job);
    };
}
